import {Period} from "./enums/period.enum";

export class SearchDto {
    fromDateUtc: Date;
    toDateUtc: Date;
    alarmRows: number;

    // offline import files use configId/configBranchId instead of global branchId
    offlineImportFileConfigId: number;
    offlineImportFileConfigBranchId: number;

    // on summary reports
    groupBy?: Period;
    timeZone?: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/search.dto.ts